import { Button, Flex } from 'antd';
import React from 'react';
import styled from 'styled-components';
import Modal from './Modal';

export type IApplyScope = 'SINGLE' | 'SERIES';

type Props = {
  visible: boolean;
  onClose: () => void;
  onConfirm: (scope: IApplyScope) => void;
  /** 'delete' hoac 'cancel' — chi doi chu trong tieu de cho khop nut nhan vien vua bam. */
  action: 'delete' | 'cancel';
};

/**
 * Hoi pham vi khi thao tac tren lich thuoc chuoi repeat.
 *
 * Chi mo khi lich that su co seriesId. Lich thuong khong bao gio thay modal nay, de luong
 * xoa/huy hien tai khong doi mot buoc nao.
 */
const ModalConfirmScope = ({ visible, onClose, onConfirm, action }: Props) => {
  const verb = action === 'delete' ? 'Delete' : 'Cancel';

  return (
    <Modal
      footerStyle={{ display: 'none' }}
      title={`${verb} repeating appointment`}
      width='auto'
      height='auto'
      open={visible}
      onCancel={onClose}
    >
      <ContentStyled>
        <p className='description'>
          This appointment is part of a repeating series.
        </p>
        <Flex vertical gap="12px">
          <Button className='scope-btn' onClick={() => onConfirm('SINGLE')}>
            {verb} only this appointment
          </Button>
          <Button className='scope-btn scope-btn--series' onClick={() => onConfirm('SERIES')}>
            {verb} this and all upcoming
          </Button>
        </Flex>
        <p className='hint'>
          Appointments already checked in or finished are never changed.
        </p>
      </ContentStyled>
    </Modal>
  );
};

export default ModalConfirmScope;

const ContentStyled = styled.div`
  width: 460px;
  padding: 8px 4px;

  .description {
    font-size: 20px;
    margin-bottom: 16px;
  }

  .hint {
    font-size: 16px;
    color: #64748B;
    margin-top: 16px;
    margin-bottom: 0;
  }

  .scope-btn {
    height: 56px;
    font-size: 20px;
    border-radius: 4px;
  }

  .scope-btn--series {
    border-color: #F5222D;
    color: #F5222D;
  }
`;
